import { render, staticRenderFns } from "./ShopSettingsPage.vue?vue&type=template&id=493c5199&scoped=true&lang=pug&"
import script from "./ShopSettingsPage.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopSettingsPage.vue?vue&type=style&index=0&id=493c5199&scoped=true&lang=stylus&"
import style1 from "./ShopSettingsPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c5199",
  null
  
)

export default component.exports